import "./AddEvent.scss";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import chevronDown from "../../assets/images/icons/chevron-down.svg";
import checkMark from "../../assets/images/icons/check-mark.svg";
import addPhoto from "../../assets/images/icons/add-photo.svg";
import calendar from "../../assets/images/icons/calendar.svg";

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import Dropdown from "../../components/Dropdown/Dropdown";
import Calendar from "react-calendar";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function AddEvent() {
    const navigate = useNavigate();

    //PHOTO UPLOAD =========================================================================================

    const [profilePic, setProfilePic] = useState(null);

    const fileInputRef = useRef(null);

    const handleFileUpload = () => {
        const something = fileInputRef.current.click();
        console.log("this is what happens when i upload a file: ", something);
    };

    //DROPDOWN =============================================================================================

    const catDropdownRef = useRef(null);
    const dressDropdownRef = useRef(null);
    const musicDropdownRef = useRef(null);

    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [showDressCodeDropdown, setShowDressCodeDropdown] = useState(false);
    const [showMusicDropdown, setShowMusicDropdown] = useState(false);

    const [selectedCats, setSelectedCats] = useState([]);
    const [selectedDress, setSelectedDress] = useState("Choose dress code");
    const [selectedMusic, setSelectedMusic] = useState([]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (catDropdownRef.current && !catDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
            if (dressDropdownRef.current && !dressDropdownRef.current.contains(event.target)) {
                setShowDressCodeDropdown(false);
            }
            if (musicDropdownRef.current && !musicDropdownRef.current.contains(event.target)) {
                setShowMusicDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //INPUT FIELDS =========================================================================================

    const [newEventName, setNewEventName] = useState("");
    const [newEventAddress, setNewEventAddress] = useState("");
    const [newEventHours, setNewEventHours] = useState("");
    const [newEventAbout, setNewEventAbout] = useState("");
    const [newEventPrice, setNewEventPrice] = useState("");
    const [newEventURL, setNewEventURL] = useState("");

    //ADDING EVENT AXIOS CALL ====================================================

    function handleAddEvent(event) {
        event.preventDefault();

        const newEvent = {
            id: uuidv4(),
            name: newEventName,
            tags: selectedCats,
            date: formatDate(newEventDate),
            hours: newEventHours,
            location: newEventAddress,
            price: newEventPrice,
            dressCode: selectedDress,
            music: selectedMusic,
            description: newEventAbout,
            url: newEventURL,
        };

        const addEvent = async () => {
            try {
                await axios.post("https://zona-app-server-584d567d8841.herokuapp.com/events", newEvent);
                navigate("/events");
            } catch (err) {
                console.log(`unable to add event. this was the error: ${err}`);
            }
        };

        addEvent();
    }

    //HANDLE CALENDAR ============================================================

    const [newEventDate, setNewEventDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    // Format the selected date to DD/MM/YYYY
    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date),
            day = "" + d.getDate(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();

        return [day.padStart(2, "0"), month.padStart(2, "0"), year].join("/");
    };

    const handleDateChange = (nextValue) => {
        setNewEventDate(nextValue);
        setShowCalendar(false); // Hide the calendar after a date is selected
    };

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <section className="add-event">
                        <div className="add-event__top">
                            <Link to="/events">
                                <img
                                    src={chevronLeft}
                                    className="add-event__top-icon"
                                    alt="chevron pointing left"
                                ></img>
                            </Link>
                            <h1 className="add-event__top-heading">Adding new event</h1>
                        </div>

                        <form onSubmit={handleAddEvent} className="add-event__form">
                            <section className="add-event__form--left">
                                <div className="add-event__form-block">
                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventName" className="add-event__form-block-group-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="eventName"
                                            id="eventName"
                                            className="add-event__form-block-group-input"
                                            value={newEventName}
                                            onChange={(event) => setNewEventName(event.target.value)}
                                            placeholder="Enter name"
                                            required
                                        />
                                    </div>

                                    <div className="add-event__form-block-group">
                                        <p className="add-event__form-block-group-label">Category</p>
                                        <div ref={catDropdownRef}>
                                            <div
                                                onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                                                className="add-event__form-block-group-input add-event__form-block-group-input--special"
                                            >
                                                <p className="add-event__form-block-group-input-text">
                                                    {selectedCats ? "Choose category" : ""}
                                                </p>
                                                <img
                                                    className="add-event__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showCategoryDropdown && (
                                                <Dropdown
                                                    type={"checkbox"}
                                                    data={[
                                                        "Clubs",
                                                        "Lounge",
                                                        "Pool Hall",
                                                        "Sports Bars",
                                                        "Dive Bars",
                                                        "Hookah Lounge",
                                                        "Karaoke",
                                                        "Drag Queen Show",
                                                        "Dinner Party",
                                                        "Live Music",
                                                        "Outdoor Venues",
                                                        "Industry Night",
                                                        "18+",
                                                        "21+",
                                                    ]}
                                                    setter={setSelectedCats}
                                                    valueSet={selectedCats}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="add-event__form-block">
                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventAddress" className="add-event__form-block-group-label">
                                            Address
                                        </label>
                                        <input
                                            type="address"
                                            name="eventAddress"
                                            id="eventAddress"
                                            className="add-event__form-block-group-input"
                                            venue={newEventAddress}
                                            onChange={(event) => setNewEventAddress(event.target.value)}
                                            placeholder="Enter address"
                                            required
                                        />
                                    </div>

                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventHours" className="add-event__form-block-group-label">
                                            Hours
                                        </label>
                                        <input
                                            type="text"
                                            name="eventHours"
                                            className="add-event__form-block-group-input"
                                            value={newEventHours}
                                            onChange={(event) => setNewEventHours(event.target.value)}
                                            placeholder="Enter hours"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-event__form-block">
                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventDate" className="add-event__form-block-group-label">
                                            Date
                                        </label>
                                        <div className="add-event__form-block-group-container">
                                            <input
                                                type="text"
                                                id="eventDate"
                                                name="eventDate"
                                                placeholder={newEventDate ? newEventDate : "DD/MM/YYYY"}
                                                className="add-event__form-block-group-input"
                                                value={newEventDate ? formatDate(newEventDate) : ""}
                                                onFocus={() => setShowCalendar(true)}
                                            />
                                            <img
                                                src={calendar}
                                                alt="calendar button"
                                                className="add-event__form-block-group-container--calendar"
                                                onClick={() => setShowCalendar(true)}
                                            />
                                        </div>
                                        <div className="edit-user__form-first-field-input-calendar">
                                            {showCalendar && (
                                                <Calendar
                                                    onChange={handleDateChange}
                                                    value={newEventDate}
                                                    next2Label={null}
                                                    prev2Label={null}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventPrice" className="add-event__form-block-group-label">
                                            Price
                                        </label>
                                        <input
                                            type="text"
                                            name="eventPrice"
                                            className="add-event__form-block-group-input"
                                            value={newEventPrice}
                                            onChange={(event) => setNewEventPrice(event.target.value)}
                                            placeholder="Enter Price"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-event__form-block">
                                    <div className="add-event__form-block-group">
                                        <p className="add-event__form-block-group-label">Dress-code</p>

                                        <div ref={dressDropdownRef}>
                                            <div
                                                onClick={() => setShowDressCodeDropdown(!showDressCodeDropdown)}
                                                className="add-event__form-block-group-input add-event__form-block-group-input--special"
                                            >
                                                <p className="add-event__form-block-group-input-text">
                                                    {selectedDress}
                                                </p>
                                                <img
                                                    className="add-event__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showDressCodeDropdown && (
                                                <Dropdown
                                                    type={"radio"}
                                                    data={["Any", "Casual", "Upscale", "Beach attire"]}
                                                    setter={setSelectedDress}
                                                    valueSet={selectedDress}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="add-event__form-block-group">
                                        <p className="add-event__form-block-group-label">Music</p>
                                        <div ref={musicDropdownRef}>
                                            <div
                                                onClick={() => setShowMusicDropdown(!showMusicDropdown)}
                                                className="add-event__form-block-group-input add-event__form-block-group-input--special"
                                            >
                                                <p className="add-event__form-block-group-input-text">
                                                    Choose music genre
                                                </p>
                                                <img
                                                    className="add-event__form-block-group-input-icon"
                                                    src={chevronDown}
                                                    alt="chevron down"
                                                ></img>
                                            </div>
                                            {showMusicDropdown && (
                                                <Dropdown
                                                    type={"checkbox"}
                                                    data={["Latin", "R&B", "Rock", "EDM", "Dance", "Reggaeton", "Jazz"]}
                                                    setter={setSelectedMusic}
                                                    valueSet={selectedMusic}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="add-event__form-block">
                                    <div className="add-event__form-block-group">
                                        <label htmlFor="eventURL" className="add-event__form-block-group-label">
                                            Website
                                        </label>
                                        <input
                                            type="text"
                                            name="eventURL"
                                            id="eventURL"
                                            className="add-event__form-block-group-input"
                                            value={newEventURL}
                                            onChange={(event) => setNewEventURL(event.target.value)}
                                            placeholder="Enter Website"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="add-event__form-block-about">
                                    <label htmlFor="eventAbout" className="add-event__form-block-group-label">
                                        About
                                    </label>
                                    <textarea
                                        rows={4}
                                        name="eventAbout"
                                        className="add-event__form-block-about-input"
                                        value={newEventAbout}
                                        onChange={(event) => setNewEventAbout(event.target.value)}
                                        placeholder="Enter event description"
                                        required
                                    />
                                </div>

                                <button type="submit" className="add-event__form-button">
                                    <p className="add-event__form-button-text">Save Information</p>
                                    <img src={checkMark} alt="a checkmark"></img>
                                </button>
                            </section>

                            <section className="add-event__form--right">
                                <div className="add-event__form-photo">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(event) => setProfilePic(event.target.files[0])}
                                    />
                                    <button
                                        type="button"
                                        className="add-event__form-photo-button"
                                        onClick={handleFileUpload}
                                    >
                                        <img src={addPhoto} alt="click here to upload a file"></img>
                                    </button>
                                </div>
                            </section>
                        </form>
                    </section>
                </article>
            </div>
        </main>
    );
}

export default AddEvent;
